import React, { FC } from 'react';
import { AnimatableStringValue, View } from 'react-native';

import TouchableElement from '@components/common/touchableElement';
import Svg from '@styles/icons/svg';
import { scale as initialScale } from '@components/frame';
import { GlassButton } from '@components/common/glassButton';
import { NAVIGATION_ARROW_SIZE } from '@v2/components/imageHandling/constants';
import { PictureProps } from '@v2/components/imageHandling/components/Picture';

interface NavigationArrowProps extends Pick<PictureProps, 'scale' | 'C'> {
  onPress: () => void;
  rotate: AnimatableStringValue;
}

export const NavigationArrow: FC<NavigationArrowProps> = ({ onPress, C, rotate, scale = initialScale }) => {
  const elSize = scale(NAVIGATION_ARROW_SIZE);

  return (
    <TouchableElement onPress={onPress}>
      {({ boxStyle, hovered }) => (
        <View
          style={[
            boxStyle,
            {
              justifyContent: 'center',
              alignItems: 'center',
              height: elSize,
            },
          ]}
        >
          <GlassButton
            style={{
              borderRadius: scale(4),
              height: elSize,
              width: elSize,
              justifyContent: 'center',
              paddingLeft: scale(11),
              transform: [{ rotate: rotate }],
            }}
            scale={scale}
          >
            {() => (
              <Svg
                icon="chevronLeft"
                width={scale(11)}
                height={scale(19)}
                color={hovered ? 'Label/Light/Primary' : 'Label/Light/AlwaysDark  Primary'}
              />
            )}
          </GlassButton>
        </View>
      )}
    </TouchableElement>
  );
};

export default NavigationArrow;
